<template>
  <div :class="['axiome-logique-container', { 'ml-12': leftMargin }]">

    <span v-if="displayPrefixOperand" class="axiome-logique-operand ml-2 mr-2" v-text="handleLogicalCases(other.key)" />

    <span class="brace-container-left" />

    <div style="display: flex;flex-direction: column;">

      <!-- Affichage des litterals -->

      <template v-if="other.literals.length">
        <PropertyValue :values="other.literals" :treeDisplay="false" :showLanguageBadge="showLanguageBadge"
          :leftMargin="false" :axiomLogicOperand="level0 == false ? handleLogicalCases(other.key) : ''"
          :inLineDisplay="inLineDisplay" />
      </template>


      <!-- Affichage des autres others -->
      <template v-if="other.blankNodes.length">
        <div :class="['display-flew-column', { 'display-flew-column-level0': level0 }]">
          <AttributeBlankNode :blankNodes="other.blankNodes" :leftMargin="false"
            :axiomLogicOperand="level0 == false ? handleLogicalCases(other.key) : ''"
            :showLanguageBadge="showLanguageBadge" :level0="false" />
        </div>
      </template>
    </div>

  </div>
</template>
<script>
import AxiomeLogicKeysEnum from "../../enums/AxiomeLogicKeysEnum";
import PropertyValue from './PropertyValue';
export default {
  name: "AttributeValueLogicalAxiom",

  components: {
    PropertyValue
  },
  methods: {
    handleLogicalCases(key) {
      let keyDisplay = '';
      switch (key) {
        case AxiomeLogicKeysEnum.INTERSECTION_OF:
          keyDisplay = "and";
          break;
        case AxiomeLogicKeysEnum.UNION_OF:
          keyDisplay = "or";
          break;
        case AxiomeLogicKeysEnum.COMPLEMENT_OF:
          keyDisplay = "not";
          break;
        case AxiomeLogicKeysEnum.MIN_QUALIFIED_CARDINALITY:
          keyDisplay = "min";
          break;
        case AxiomeLogicKeysEnum.ONE_OF:
          keyDisplay = "one of";
          break;
        case AxiomeLogicKeysEnum.ALL_VALUES_FROM:
          keyDisplay = "only";
          break;
        default:
          keyDisplay = key;
      }

      return keyDisplay.replace('http://www.w3.org/2002/07/owl', '');
    },
  },
  computed: {
    /**
     * Retourne si l'affichage doit etre en ligne ou à plat
     */
    inlineDisplay() {
      let nbElement = this.other.literals.length + this.other.blankNodes.length;
      return nbElement > 1;
    }
  },

  props: {
    level0: {
      type: Boolean,
      default: false,
    },
    displayPrefixOperand: {
      type: Boolean,
      default: false
    },
    other: {
      type: Object,
      required: true
    },
    leftMargin: {
      type: Boolean,
      default: true
    },
    showLanguageBadge: {
      type: Boolean,
      default: false
    },
  }
};

</script>
